<main class="main">
  <app-notification-modal></app-notification-modal>
  <app-federated-redirect-overlay></app-federated-redirect-overlay>
  <!-- <button class="btn btn--secondary w-100" (click)="openChangePasswordModal()">Recuperar Contraseña</button>
  <app-change-password-modal></app-change-password-modal> -->
  <div class="edutin-academy">
    <div class="auth fw-600">
      <div class="auth__container" [ngClass]="{'bg-white': isNotLogoutRoute}">
        <div class="progress-line" *ngIf="isLoadingAFederated() && !authService.isReturningFromRedirect()"></div> <!-- Progreso cuando esté iniciando con federado (popup) -->
        <div class="auth__container__content" [class.auth__container__content--business]="isBusinessSignup">
          <!-- Main Section -->
          <app-auth-header class="flex column gap-6" *ngIf="isNotLogoutRoute"></app-auth-header>
          <!-- Forms Section -->
          <div class="route-container" [@routeAnimations]="prepareRoute(outlet)"
            (@routeAnimations.start)="onAnimationStart()" (@routeAnimations.done)="onAnimationDone()"
            [class.animating]="isAnimating">
            <router-outlet #outlet="outlet"></router-outlet>
          </div>
        </div>
      </div>

      <div class="auth-terms" *ngIf="router.url == '/signup' || router.url.includes('/signup/continue')">
        {{ 'auth.app.terms.createAccountAccept' | translate }}
        <a href="https://edutin.com/pages/terminos" target="_blank"> {{ 'auth.app.terms.termsAndConditions' | translate }}</a> {{ 'auth.app.terms.ofEdutinInc' | translate }}
        <div>
          {{ 'auth.app.terms.recaptchaNotice' | translate }}
          <a href="https://policies.google.com/privacy" target="_blank">{{ 'auth.app.terms.privacyPolicy' | translate }}</a> {{ 'auth.app.terms.and' | translate }}
          <a href="https://policies.google.com/terms" target="_blank">{{ 'auth.app.terms.termsOfService' | translate }}</a> {{ 'auth.app.terms.apply' | translate }}
        </div>
      </div>

    </div>
  </div>
</main>
